import { render, staticRenderFns } from "./ViewAnalyticsTop.vue?vue&type=template&id=970fba80&scoped=true&"
import script from "./ViewAnalyticsTop.vue?vue&type=script&lang=js&"
export * from "./ViewAnalyticsTop.vue?vue&type=script&lang=js&"
import style0 from "./ViewAnalyticsTop.vue?vue&type=style&index=0&id=970fba80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "970fba80",
  null
  
)

export default component.exports